import { History } from 'history';
import * as React from 'react';
// import { Helmet } from 'react-helmet';
import Slider from 'react-slick';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { CategoryHotels } from '../core/CategoryHotels';
import { TRIPADVISOR } from '../core/index';
import { ContactFormReview } from '../core/ContactFormReview';
import { scrollToTop } from '../core/index';
import { SearchForm } from '../core/SearchForm';
import { HotelBedData, SecurityData, HotelBedCatalogData } from '../shared/index';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
// import { getStringFilter } from '../utils/get-season-storage-filter';
import { isNull } from '../utils/index'; 
import { RoomAvailabilityList } from './RoomAvailabilityList';
// import { sendHotelAvailibilityRequest } from 'src/utils/req-available-helper'; 
// import { ShowRoomDetail } from '../hotels/ShowRoomDetail';
// import { FirebaseRealtimeDbBasedHotelRequestCheckerTool } from './req-available/FirebaseRealtimeDbBasedHotelRequestCheckerTool';
import { HotelRequestCheckerTool } from './HotelRequestCheckerTool';

export interface HotelDetailProps extends BaseComponentProps {
    lang: string;
    id: number | string;
    userLogin: SecurityData.ApplicationUser;
    slug: string;
    history?: History | any;
    currency: string;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    /** 
     * filter awal untuk data
     */
    // initialFilter: HotelBedData.SearchFilter;
    responKey?: string;
    reqAvailableDetailId?: number | any;
    updateInternalFilter: (filter: HotelBedData.SearchFilter) => any;
    night?: string;
    firebaseApp: firebase.app.App;

}
export interface HotelDetailState extends BaseComponentState {
    hotel: HotelBedCatalogData.Hotel;
    images: string[];
    imageTypes: HotelBedData.HotelDetailCategory[];
    facilityGroups: HotelBedData.HotelDetailFacilitiesGroup[];
    currentFilter: HotelBedData.SearchFilter | any;
    hotelCodes: number[] | any[];
    page: number;
    externalFilter: any;
    responKey: string;
    requesting: boolean;
    hotels: HotelBedData.PagedHotelbedData | any;
    error?: boolean;
    errorMessage?: string;
    filterRateChange: boolean;
    roomDetailOpen?: boolean;
    roomToOpen?: HotelBedData.Room;
    filterRate: {
        maxRate: number,
        minRate: number
    };
    reqAvailableDetailId: number | any;
}

export class HotelDetail extends BaseComponent<HotelDetailProps, HotelDetailState> {
    divElement: any;
    timeout: any = null;
    checkerRequestAvailable: HotelRequestCheckerTool;
    constructor(props: HotelDetailProps) {
        super(props);
        let responKey = '';
        if (props.responKey) {
            responKey = props.responKey;
        }

        this.state = {
            hotel: {},
            images: [],
            imageTypes: [],
            facilityGroups: [],
            currentFilter: null,
            hotelCodes: [],
            page: 0,
            externalFilter: {},
            responKey: responKey,
            requesting: true,
            hotels: null,
            filterRateChange: false,
            filterRate: {
                maxRate: 100000000,
                minRate: 0
            },
            reqAvailableDetailId: this.props.reqAvailableDetailId && this.props.reqAvailableDetailId !== 0 && this.props.reqAvailableDetailId !== '' ? this.props.reqAvailableDetailId : null
            // filter : isNull(this.props.filter) ? {} : this.props.filter
        };
    }

    componentDidUpdate(prevProps: HotelDetailProps, prevState: HotelDetailState) {
        scrollToTop();
        if (prevProps.lang !== this.props.lang || prevProps.id !== this.props.id) {
            this.getData();
        }
    } 
    componentDidMount() {
        this.getData(); 
         
    }
  
    getData: () => any = () => { 
        getAjaxhelper().post(`/dynamics/hb-api/hotel-detail`, {
            lang: this.props.lang,
            hotelCode: this.props.id
        }).then(
            (data: any) => {
                let imgs: string[] = [];
                if (!isNull(data.HotelImageSumaryData)) {
                    for (let a of data.HotelImageSumaryData) {
                        imgs.push(a.path);
                    } 
                }
                this.setState({ requesting: false, hotel: data, images: imgs });
            }).catch((exc) => { console.error('error: ', exc); });
    } 

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
          
        let hotelDes: any = '';
        let banner: any = '';
        let hotelName: any = '';
        let address: any = "";
        let idHotel: any = this.props.id;
        let category: any = <span />;
        let maplink = <span />;
        let settings = {
            dots: false,
            infinite: true,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            pauseOnHover: true,
            // lazyLoad: true,
            fade: false
        };
        let slide = [];
        let hotelFacilities: any[] = []; 
        let imageGaleriesType = [];
        if (this.state.hotel) {
            if (!isNull(this.state.hotel.name)) {
                hotelName = this.state.hotel.name;
            }
            if (!isNull(this.state.hotel.description)) {
                hotelDes = this.state.hotel.description;
            }
            if (!isNull(this.state.hotel.address)) {
                address = this.state.hotel.address!;
            }

            if (!isNull(this.state.hotel.Category)) {
                category = <CategoryHotels key='cat' star={this.state.hotel.Category!.simpleCode!} />;
            }

            if (this.state.hotel.coordinates_latitude && this.state.hotel.coordinates_longitude) {
                // let cord = this.state.hotel.coordinates;
                maplink = (
                    <a key={'loc'} href={`/maps?rk=${this.props.responKey}&id=${this.props.id}`} target="_blank" style={{ color: '#4f00ff', fontSize: 14 }}>
                        <i className="fa fa-map-marker" />   {address} - View on map
                    </a>
                );
                address = '';
            }
            if (!isNull(this.state.hotel.HotelImageSumaryData) && this.state.hotel.HotelImageSumaryData!.length > 0) {
                let images: any[] | any = this.state.hotel.HotelImageSumaryData;
                banner = images[0].path ? images[0].path : '';
                let ketemu = 0;
                
                for (let image of images) {
                    if (image.ImageType.code === 'GEN') {
                        banner = image.path;
                        ketemu = 1;
                    } else {
                        banner = image.path;
                    }
                    if (ketemu === 1) {
                        break;
                    }
                }
                let idxImageType: {[nama: string]: string[]} = {};
                for (let image of images) { 
                    if (!idxImageType[image.ImageType.description]) {
                        idxImageType[image.ImageType.description] = [];
                    }
                    idxImageType[image.ImageType.description].push(image.path);
                }
                // ======== FIX tinggi_banner harus dicari =========== 
                // let tinggiBanner = 500;
                let jumlahImageType = Object.keys(idxImageType).length;
                if (jumlahImageType === 0) {
                    jumlahImageType = 1;
                }
                let ti = ((500 + 10) / jumlahImageType) - 10;
                for (let a of Object.keys(idxImageType)) {
                    imageGaleriesType.push(
                        <div
                            className='hotel-images-child'
                            style={{
                                height: ti,
                                backgroundImage: `url("${idxImageType[a][0]}")`,
                            }}
                            onClick={() => {
                                this.setStateHelper(st => st.images = idxImageType[a]);
                            }}
                        >
                            <div style={{ textAlign: 'center', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                <h4
                                    style={{
                                        color: '#ffffff',
                                        textAlign: 'center',
                                        height: '100%',
                                        lineHeight: `${ti}px`,
                                    }}
                                > {a}
                                </h4>
                            </div>
                        </div>
                    );
                } 
                
            } 
            let imgLop = 0;
            for (let a of this.state.images!) {
                imgLop++;
                slide.push(
                    <div>
                        <div className='hotel-image-slider' key={`image${imgLop}`} style={{ backgroundImage: `url("${a}")`, width: '100%' }}>
                            <div className="container home-banner" />
                        </div>
                    </div>

                );
            }
            let lop = 0;
            if (this.state.hotel && this.state.hotel.facilitiesGroup) {
                for (let a of this.state.hotel.facilitiesGroup!) {
                    if (a.code !== 20 && a.code !== 30) { // && a.code !== 20 && a.code !== 30 && a.code !== 40
                        let fasDetail = [];
                        let lop1 = 0;
                        for (let b of a.Facilities!) {
                            lop1++;
                            let style = {};
                            let ico = <i className="ti-check" />;
                            if (b.indLogic === "FALSE") {
                                ico = <i className="ti-close" />; 
                            } else {
                                style = {};
                            } 
                            
                            if (b.indYesOrNo === "FALSE") { 
                                style = { fontStyle: "italic" };
                            } else {
                                style = { fontWeight: 500 };
                            }

                            let bintang = <span style={{ color: 'FF0000' }}>*</span>;
                            if (b.indFee === "FALSE") {
                                bintang = <span/>;
                            }
                            let buri = <span />;
                            if (!isNull(b.number) && b.number !== 0) {
                                buri = <span> - {b.number}</span>;
                            }
                            fasDetail.push(
                                <div key={lop1} style={style} className="col-md-3">{ico} {b.description!} {buri} {bintang}</div>
                            );
                        }
                        lop++;
                        hotelFacilities.push(
                            <div key={lop} className='' style={{ marginTop: 30 }}>
                                <h4 className="facilitiesHeader" style={{ width: '100%', borderBottom: '1px solid' }} > {a.description}</h4>
                                <div className="row" style={{ width: '100%' }}> {fasDetail}</div>
                            </div>
                        );
                    }
                }
            }
        }
        let roomAvailabel = <span/>;
        if (this.state.reqAvailableDetailId) {
           roomAvailabel = <RoomAvailabilityList  key={this.state.reqAvailableDetailId} roomShow={5} currencyCode={this.props.currency} firebaseApp={this.props.firebaseApp} history={this.props.history} lang={this.props.lang} classright=''   reqAvailableDetailId={this.state.reqAvailableDetailId} reqKey={this.props.responKey!} night={this.props.night!}/>;
        }
        return (
            <div className='hotel-detail'>
                <div className="container broadcom  " style={{ paddingTop: 140 }}>
                    <p>
                        Hotels / {hotelName}
                    </p>
                </div>
                <div className="container   bg-white" style={{ paddingTop: 20 }}>
                    <h3 className=" ">{hotelName} {category}</h3>
                    <p>{address} {maplink}</p>
                    <div className='hotel-image-slider' style={{ backgroundImage: `url("https://photos.hotelbeds.com/giata/bigger/${banner}")` }} >
                        <Slider className='slick-hotel-detail' {...settings}>
                            {slide}
                        </Slider>
                    </div>

                    <div className='hotel-image-list' >
                        <div className="" style={{ paddingLeft: 10 }} >
                            {imageGaleriesType}
                        </div>
                    </div>
                </div>
                <section className="container bg-white"  >
                    <div className=''>
                        <h4>Hotel Description</h4>
                        <p>{hotelDes}</p>
                    </div>
                </section>
                <section className="container" style={{ marginTop: 20 }}>
                    <div className='col-md-9  bg-white' style={{ margin: '0 -15px', padding: 0, minHeight: 461, border: '1px solid #ccc', borderRadius: 5 }}>
                        {roomAvailabel}
                    </div>
                    <div className="col-md-3 search-form-hotel-detail "  >
                        <h3>Search Hotel</h3>
                        <SearchForm
                            lang={this.props.lang}
                            showtitle={false}
                            style='vertical'
                            count={15}
                            getHotels={this.props.getHotels}
                            externalFilter={{}}
                            filter={this.state.currentFilter}
                            /* key={btoa(JSON.stringify(this.state.currentFilter))} */
                        />
                    </div>
                </section>

                <section className="container bg-white" style={{ marginTop: 20, border: '1px solid #ccc', borderRadius: 5 , paddingTop: 10 }} >
                    <Tabs>
                        <TabList>
                            <Tab>General Information</Tab>
                            <Tab>Reviews</Tab>
                        </TabList>
                        <TabPanel>
                            {hotelFacilities}
                        </TabPanel>
                        <TabPanel>
                            <iframe style={{ height: '100vh' }} width="100%" frameBorder='0' src={`${TRIPADVISOR.WidgetEmbed}${idHotel}`} />
                        </TabPanel>
                    </Tabs>
                </section>

                <section className="container bg-white" style={{ marginTop: 20, padding: 15 }} >
                    <h4>Leave a Reply</h4>
                    <p>Your email address will not be published. Required fields are marked *</p>
                    <ContactFormReview userLogin={this.props.userLogin} lang={this.props.lang} from={this.props.slug} userId={isNull(this.props.userLogin) ? 0 : this.props.userLogin.id} />
                </section>
                <section className="container-fluid container-fullw">{/**/}</section>
 
            </div>
        );
    }  
}

// firebaseApp.firestore().doc(`userData/${this.props.uuid}/bookingData/${this.props.responKey}`).set({fbData})


// WEBPACK FOOTER //
// ./src/hotels/HotelDetail.tsx